import React from 'react';
import {Header as HeaderStyle, Logo, Content, Clear, Nav, HrVert, MenuOptions, ToolBar, Title, Hr} from './styled';
import Logotipo from '../../assets/svg/logo.svg';
import {CgMenu} from 'react-icons/cg';
import {Avatar, Menu, MenuItem, MenuProps, Slide, withStyles} from "@material-ui/core";
import {IoIosPaper, IoMdImages} from 'react-icons/io';
import {BsFileBarGraphFill, BsFillCameraFill} from 'react-icons/bs';
import {AiTwotoneHome} from 'react-icons/ai';
import {NavLink, useNavigate, useLocation} from "react-router-dom";
import {FaTruckMoving} from "react-icons/fa";
import { UserContext } from '../../UserContext';
import {FaShoppingBag} from 'react-icons/fa';
import {MdGroup, MdGroupAdd, MdOutlineAttachMoney} from 'react-icons/md';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PersonIcon from '@material-ui/icons/Person';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
        marginTop: 10
    },
})((props: MenuProps) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
));

const StyledMenuItem = withStyles((theme) => ({
    root: {
        '&:focus': {
            backgroundColor: 'transparent',
            '&:hover': {
                backgroundColor: '#f1f1f1'
            },
        },
    },    
}))(MenuItem);

const Header: React.FC = () => {
    const [display, setDisplay] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const {userLogout, data} = React.useContext(UserContext);

    const navigate = useNavigate();
    const location = useLocation();

    const onButtonClick = () => {
        setDisplay(!display);
    }

    const onCloseMenu = () => {
        setDisplay(false);
    }
    
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const toEdit = () => {
        handleClose();
        navigate('editar/perfil');
    }

    if(!data.PKGrupo) return <></>;

    return (
        <HeaderStyle inicio={location.pathname === '/area-restrita/usuario/inicio'}>
            <Content>
                <Nav>
                    <ToolBar show={display}>
                        <CgMenu size={35} color={"#666"} onClick={onButtonClick}/>
                        <HrVert/>
                        <Avatar alt={data.sNome} onClick={handleClick} src="/static/images/avatar/sdsdsds1.jpg"/>
                        <StyledMenu
                            id="customized-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            <StyledMenuItem onClick={() => toEdit()}>
                                <ListItemIcon>
                                    <PersonIcon fontSize="small"/>
                                </ListItemIcon>
                                <ListItemText primary="Editar Perfil"/>
                            </StyledMenuItem>
                            <StyledMenuItem onClick={() => userLogout()}>
                                <ListItemIcon>
                                    <ExitToAppIcon fontSize="small"/>
                                </ListItemIcon>
                                <ListItemText primary="Sair"/>
                            </StyledMenuItem>
                        </StyledMenu>
                    </ToolBar>
                    <div className="ds-flex align-items-center">
                        <Logo>                            
                            <img 
                                src={Logotipo} 
                                title="Sultan Veste a Casa, Área Restrita"
                                alt="Sultan Veste a Casa, Área Restrita"
                            />                        
                        </Logo>
                        <Title>SULTAN VESTE A CASA</Title>
                    </div>  
                    <Hr/>               
                    <Slide direction="right" in={display}>
                        <MenuOptions show={true}>
                            <NavLink title="Inicio" activeClassName="selected" onClick={onCloseMenu} to={`${process.env.PUBLIC_URL}/usuario/inicio`}>
                                <li>
                                    <AiTwotoneHome color={"#666"} size={20}/>
                                    <span>INICIO</span>
                                </li>
                            </NavLink>
                            {['100', '101', '102', '103', '104', '105', '107', '108'].includes(data.PKGrupo) &&
                                <NavLink title="Repositório" activeClassName="selected" onClick={onCloseMenu} to={`${process.env.PUBLIC_URL}/usuario/repositorio`}>
                                    <li>
                                        <IoMdImages color={"#666"} size={20}/>
                                        <span>REPOSITÓRIO</span>
                                    </li>
                                </NavLink>
                            }                           
                            {['100', '101', '104', '105', '107', '108'].includes(data.PKGrupo) &&
                                <NavLink title="Duplicatas em Aberto" activeClassName="selected" onClick={onCloseMenu} to={`${process.env.PUBLIC_URL}/usuario/duplicatas`}>
                                    <li>
                                        <IoIosPaper color={"#666"} size={20}/>
                                        <span>DUPLICATAS EM ABERTO</span>
                                    </li>
                                </NavLink>
                            }
                            {['100', '103'].includes(data.PKGrupo) &&
                                <NavLink title="Enviar Imagens" activeClassName="selected" onClick={onCloseMenu} to={`${process.env.PUBLIC_URL}/usuario/enviar-imagens`}>
                                    <li>
                                        <BsFillCameraFill color={"#666"} size={20}/>
                                        <span>ENVIAR IMAGENS</span>
                                    </li>
                                </NavLink>
                            }
                            {['100', '108'].includes(data.PKGrupo) &&
                                <NavLink title="Usuários Pendentes" activeClassName="selected" onClick={onCloseMenu} to={`${process.env.PUBLIC_URL}/usuario/usuarios-pendentes`}>
                                    <li>
                                        <MdGroupAdd color={"#666"} size={20}/>
                                        <span>USUÁRIOS PENDENTES</span>
                                    </li>
                                </NavLink>
                            }
                            {['100', '101', '105', '108'].includes(data.PKGrupo) &&
                                <NavLink title="Usuários Aprovados" activeClassName="selected" onClick={onCloseMenu} to={`${process.env.PUBLIC_URL}/usuario/usuarios-aprovados`}>
                                    <li>
                                        <MdGroup color={"#666"} size={20}/>
                                        <span>USUÁRIOS APROVADOS</span>
                                    </li>
                                </NavLink>
                            }
                            {['100','101', '105', '109'].includes(data.PKGrupo) &&
                                <NavLink title="Controle de Frete" activeClassName="selected" onClick={onCloseMenu} to={`${process.env.PUBLIC_URL}/usuario/controle-de-frete`}>
                                    <li>
                                        <FaTruckMoving color={"#666"} size={20}/>
                                        <span>CONTROLE DE FRETE</span>
                                    </li>
                                </NavLink>
                            }  
                            {['100', '101', '102', '104', '105', '107', '108'].includes(data.PKGrupo) &&
                                <NavLink title="Meus Pedidos" activeClassName="selected" onClick={onCloseMenu} to={`${process.env.PUBLIC_URL}/usuario/meus-pedidos`}>
                                    <li>
                                        <FaShoppingBag color={"#666"} size={20}/>
                                        <span>MEUS PEDIDOS</span>
                                    </li>
                                </NavLink>                       
                            }
                            {['100', '101', '104'].includes(data.PKGrupo) &&
                                <NavLink title="Simulador de Preços" activeClassName="selected" onClick={onCloseMenu} to={`${process.env.PUBLIC_URL}/usuario/simulador-de-preco`}>
                                    <li>
                                        <MdOutlineAttachMoney color={"#666"} size={20}/>
                                        <span>SIMULADOR DE PREÇOS COM ST</span>
                                    </li>
                                </NavLink>                       
                            }
                            {['100', '101', '103', '104', '105', '108', '109', '110', '111'].includes(data.PKGrupo) &&
                                <NavLink title="Simulador de Preços" activeClassName="selected" onClick={onCloseMenu} to={`${process.env.PUBLIC_URL}/usuario/dashboard-bi`}>
                                    <li>
                                        <BsFileBarGraphFill color={"#666"} size={20}/>
                                        <span>DASHBOARD BI</span>
                                    </li>
                                </NavLink>                       
                            }
                        </MenuOptions>
                    </Slide>
                </Nav>
                <Clear/>
            </Content>
        </HeaderStyle>
    );
}

export default Header;